<div class="login-page">
  <div class="login-container">

  <!-- Reset Password Left Side Section Code Start -->      
    <div class="login-form-container forgot-password-container" role="main">
      <div class="logo"><img src="assets/images/logo.svg" alt="Logo" /></div>
      <h1 class="heading-level-4 gray-color mt-40 mb-20">Reset Your Password</h1>

      <form class="form-style1 reset_password_form mb-0" #userForm="ngForm" (ngSubmit)="resetPassword(userForm)"
          novalidate>
          <div class="form-group mb-20">
              <input title="email" aria-label="email" type="email" required name="email" [readonly]="true" [(ngModel)]="user.email" />
              <label>Email</label>
            </div>
          <div class="form-group mb-20">
              <input title="password" aria-label="password" type="password" required name="newPassword" [(ngModel)]="user.newPassword" autocomplete="new-password"
                id="newPassword" placeholder=""/>
                <label>New Password</label>
              <img class="icon ml-5 reset_eye_img" alt="newPassword_img" src="assets/images/eye_password.svg" id="newPassword_img" tabindex="0"
                (click)="revealPassword('newPassword', 'newPassword_img')" />
          </div>
          <div class="form-group mb-20">
              <input title="password" aria-label="password" type="password" required name="confPassword" [(ngModel)]="user.confPassword" autocomplete="new-password"
                id="confPassword" placeholder=""/>
                <label>Confirm Password</label>
              <img class="icon ml-5 reset_eye_img" alt="confPassword_img" src="assets/images/eye_password.svg" id="confPassword_img" tabindex="0"
                (click)="revealPassword('confPassword', 'confPassword_img')" />
          </div>
          <p class="pwd_hint full-width">
            Your password cannot contain your email address, first name, or
            last name. It must be minimum of 8 characters in length,
            containing at least one upper case letter, one lower case letter,
            one number, and one special character.
          </p>
          <div class="button-container">
            <div *ngIf="errorMsg" class="errormsg" role="alert" [innerHTML]="errorMsg"></div>
            <button type="submit" class="button-style1 width-135">
              Submit
            </button>
          </div>
      </form>
      <div class="login-bottom-section" aria-label="contentinfo">
        <img src="assets/images/ABA-logo.png" alt="ABA Logo" aria-label="Footer Logo"/>
        <p>© {{ currentYearCopyRight }} American Bankers Association</p>        
      </div>
    </div>
   
    <div class="login-image-container" role="banner">
      <img class="login-banner" src="assets/images/login-right.webp" alt="Reset Password" />
    </div>    

  </div>
</div>
